<template>
  <div>
    <Nav />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Nav from '@/components/nav.vue'
import Footer from '@/components/footer.vue'
export default {
  components: {
    Nav,
    Footer
  }
}
</script>

<style lang="scss" scoped></style>
